import _has from 'lodash/has';

export const getRequiredExtraData = data => {
  const requiredExtraData = [];

  if (!_has(data, 'gender')) {
    requiredExtraData.push('gender');
  }
  if (!_has(data, 'birthdayMonthYear')) {
    requiredExtraData.push('birthdayMonthYear');
  }
  if (!_has(data, 'firstName')) {
    requiredExtraData.push('firstName');
  }
  if (!_has(data, 'lastName')) {
    requiredExtraData.push('lastName');
  }
  if (!_has(data, 'subscription')) {
    requiredExtraData.push('subscription');
  }

  return requiredExtraData;
};
